import { render, staticRenderFns } from "./TextInAccordion.vue?vue&type=template&id=2416766c"
import script from "./TextInAccordion.vue?vue&type=script&lang=js"
export * from "./TextInAccordion.vue?vue&type=script&lang=js"
import style0 from "./TextInAccordion.vue?vue&type=style&index=0&id=2416766c&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports